import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4260906d"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "DownvoteComponent"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "DownvoteComponent__text"
  }, " How was the last response? ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", {
    "class": _normalizeClass({
      'DownvoteComponent__iconholder--down': true,
      'DownvoteComponent__iconholder': true,
      'DownvoteComponent__iconholder--voted': _ctx.$store.state.voted && _ctx.$store.state.upvoted,
      'DownvoteComponent__iconholder--voted-accepted': _ctx.$store.state.voted && _ctx.$store.state.downvoted
    }),
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.handleVotes('down');
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-thumbs-down",
    "class": _normalizeClass({
      'fas': true,
      'DownvoteComponent__icon': true,
      'DownvoteComponent--down': true,
      'DownvoteComponent__icon--voted': _ctx.$store.state.voted
    })
  }, null, 8, ["class"])], 2), _createElementVNode("span", {
    "class": _normalizeClass({
      'DownvoteComponent__iconholder--up': true,
      'DownvoteComponent__iconholder': true,
      'DownvoteComponent__iconholder--voted': _ctx.$store.state.voted && _ctx.$store.state.downvoted,
      'DownvoteComponent__iconholder--voted-accepted': _ctx.$store.state.voted && _ctx.$store.state.upvoted
    }),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleVotes('up');
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-thumbs-up",
    "class": _normalizeClass({
      'fas': true,
      'DownvoteComponent__icon': true,
      'DownvoteComponent--up': true,
      'DownvoteComponent__icon--voted': _ctx.$store.state.voted
    })
  }, null, 8, ["class"])], 2)]);
}